import * as types from './types';

const initialState = {
  reputationLevel: [],
  responseRate: [],
  publications: [],
  permanence: [],
  error: false,
  loading: false,
  mainReputationLevel: null
};

function scoreReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_SCORE:
      return {
        ...state,
        error: false,
        loading: true
      };
    case types.FETCH_SCORE_COMPLETED:
      return {
        ...state,
        reputationLevel: action.payload && action.payload.reputationLevel ? action.payload.reputationLevel : [],
        responseRate: action.payload && action.payload.responseRate ? action.payload.responseRate : [],
        publications: action.payload && action.payload.publications ? action.payload.publications : [],
        permanence: action.payload && action.payload.permanence ? action.payload.permanence : [],
        // nivel de reputacion de la sucursal principal del usuario para DL's
        mainReputationLevel: state.mainReputationLevel || action.payload?.reputationLevel?.level || 'NA',
        error: false,
        loading: false
      };
    case types.FETCH_SCORE_FAILED:
      return {
        ...state,
        error: true,
        reputationLevel: [],
        loading: false,
        // nivel de reputacion de la sucursal principal del usuario para DL's
        mainReputationLevel: 'NA'
      };

    default:
      return state;
  }
}

export { scoreReducer };
